import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { buildAiHubObjectAnalysisPath } from "../constants";

type ObjectAnalysisRowActionsProps = Readonly<{
  assessmentId: string;
}>;

export default function ObjectAnalysisRowActions({
  assessmentId,
}: ObjectAnalysisRowActionsProps) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <IconButton
        aria-label={`View assessment ${assessmentId}`}
        size="small"
        sx={{ p: 0.75 }}
        onClick={(event) => {
          event.stopPropagation();
          navigate(buildAiHubObjectAnalysisPath(assessmentId));
        }}
      >
        <VisibilityOutlinedIcon sx={{ fontSize: 18, color: "#A6A6A6" }} />
      </IconButton>
    </Box>
  );
}
